import React from 'react'
import '../../styles/WelcomeSection/WelcomeHeader.scss'
import introLogoImage from '../../static/images/intro_logo.svg'

const IntroLogo = () => {
  return (
        <div className="intro_logo">
            <img
                src={introLogoImage}
                alt="SmartAsset logo"
            />
        </div>
  )
}

export default IntroLogo
